<template>
  <div
    class="header-row-statistics"
    :style="`
      height: var(--statistics_height);
      ${isSpatialView?'width: calc((var(--project_taktplan_ta_header_width) + var(--project_taktplan_spatial_header_width)) * 1px * var(--taktplan_zoom));':'width: calc(((var(--project_taktplan_ta_header_width) + var(--project_taktplan_spatial_header_width)) * 1px + var(--workpackage_width) + 8px) * var(--taktplan_zoom));'}
      `"
    >
    <div
      class="statistic-basic-info"
      :style="isSpatialView?'width: calc(((var(--project_taktplan_ta_header_width) + var(--project_taktplan_spatial_header_width)) * 1px ) * var(--taktplan_zoom));':'width: calc(((var(--project_taktplan_ta_header_width) + var(--project_taktplan_spatial_header_width)) * 1px + var(--workpackage_width) + 8px) * var(--taktplan_zoom));'"
      >
      <slot name="basic-info"/>
    </div>
    <div class="statistic-settings">
      <slot name="statistic-settings"/>
    </div>
  </div>
</template>
<script>
export default {
  props: ['set_statistics_height', 'isSpatialView'],
  data: () => ({
  }),
}
</script>
<style>
  .header-row-statistics {
    position: sticky;
    position: -webkit-sticky;
    display: flex;
    justify-content: space-between;
    /* left: calc((var(--workpackage_width) + 8px) * -3 * var(--taktplan_zoom));
    width: calc((var(--workpackage_width) + 8px) * 4 * var(--taktplan_zoom)); */
    left: 0px;
    width: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom));
    background-color: #121212;
    /* backdrop-filter: blur(5px); */
    border-style: solid;
    border-color: var(--header_border_color);
    border-width: 0px 1px 0px 0px;
    z-index: 5;
    transition: height 300ms ease-in-out
  }
  .statistic-settings {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    overflow: hidden;
    background-color: var(--v-color-1-base);
  }
  .statistic-basic-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: calc((var(--project_taktplan_ta_header_width) * 1px - var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    overflow: hidden;
    background-color: var(--v-color-1-base);
  }
</style>
